import NotFoundView from "../views/NotFoundView.vue";
//----------------------------
// routes
//----------------------------
export default [
  {
    path: "/:catchAll(.*)",
    name: "notFoundView",
    component: NotFoundView,
  },
]